export default {
  name: 'accordion',
  component(settings) {
    return {
      // Initialize component
      allowMultipleOpen: settings.allow_multiple_open || false,
      // Central state management for all accordion items
      itemStates: {},

      get accordionItems() {
        return this.$el.querySelectorAll('.accordion-item');
      },

      init() {
        // Initialize item states based on default settings
        this.initializeItemStates();

        // Apply accordion styles based on settings
        this.applyStyles();

        // Set up spacing between items
        if (settings.vertical_spacing) {
          this.applyVerticalSpacing();
        }
      },

      // Initialize states for all accordion items
      initializeItemStates() {
        let firstVisibleItemFound = false;
        
        this.accordionItems.forEach((item) => {
          const blockId = item.dataset.blockId;
          const style = window.getComputedStyle(item);
          const display = style.getPropertyValue('display');
          const isVisible = display !== 'none';
          
          // Check if this item should be open by default from its data attribute
          const hasOpenByDefault = item.dataset.openByDefault === 'true';
          
          // Determine if this item should be open
          let shouldBeOpen = false;
          
          if (hasOpenByDefault && isVisible) {
            // If this item is marked to be open by default and is visible, open it
            shouldBeOpen = true;
          }
          
          this.itemStates[blockId] = shouldBeOpen;
        });
      },
      
      // Helper method to check if any items have openByDefault set
      hasAnyOpenByDefault() {
        return Array.from(this.accordionItems).some(item => 
          item.dataset.openByDefault === 'true' && 
          window.getComputedStyle(item).getPropertyValue('display') !== 'none'
        );
      },

      // Check if specific item is open
      isOpen(blockId) {
        return this.itemStates[blockId] || false;
      },

      // Toggle specific accordion item
      toggleItem(blockId) {
        // If not allowing multiple open, close all others first
        if (!this.allowMultipleOpen) {
          Object.keys(this.itemStates).forEach(id => {
            if (id !== blockId) {
              this.itemStates[id] = false;
            }
          });
        }
        
        // Toggle the clicked item
        this.itemStates[blockId] = !this.itemStates[blockId];
      },

      // Apply styling based on accordion settings
      applyStyles() {
        this.accordionItems.forEach((item, index) => {
          // Apply border radius to first and last items if set
          if (settings.border_radius > 0) {
            if (index === 0) {
              item.style.borderTopLeftRadius = `${settings.border_radius}px`;
              item.style.borderTopRightRadius = `${settings.border_radius}px`;
            }
            if (index === this.accordionItems.length - 1) {
              item.style.borderBottomLeftRadius = `${settings.border_radius}px`;
              item.style.borderBottomRightRadius = `${settings.border_radius}px`;
            }
          }

          // Apply accordion style classes
          switch (settings.accordion_style) {
            case 'modern':
              item.classList.add('bg-white', 'shadow-sm', 'mb-2');
              break;
            case 'minimal':
              item.classList.add('border-l-0', 'border-r-0', 'border-t-0');
              break;
            case 'bordered':
              item.classList.add('border', 'border-gray-300', 'mb-2', 'rounded');
              break;
            default:
              // Default style - keep existing classes
              break;
          }
        });
      },

      // Apply vertical spacing between accordion items
      applyVerticalSpacing() {
        this.accordionItems.forEach((item, index) => {
          if (index > 0) {
            item.style.marginTop = `${settings.vertical_spacing}px`;
          }
        });
      },

      // Method to open all items (for debugging/testing)
      openAll() {
        Object.keys(this.itemStates).forEach(blockId => {
          this.itemStates[blockId] = true;
        });
      },

      // Method to close all items
      closeAll() {
        Object.keys(this.itemStates).forEach(blockId => {
          this.itemStates[blockId] = false;
        });
      },

      // Method to toggle specific item by index
      toggleItemByIndex(index) {
        if (this.accordionItems[index]) {
          const blockId = this.accordionItems[index].dataset.blockId;
          this.toggleItem(blockId);
        }
      }
    };
  }
};
